//
//
//
//

import PageWrap from '@/components/page_wrap'
import Cookie from '@/utils/cookie'

import Service from '@/service/public'


export default {
    name: 'WebPage',
    data () {
        return {
            src: '',
            title: ''
        }
    },
    created () {
        const options = this.$route.query
        console.error('options', options)
        this.setWebViewSrc(options)
    },
    watch: {
        src (link) {
            if (link) {
                window.location.replace(link)
            }
        }
    },
    methods: {
        check () {
            Service.checkUrl(this.src).then(({ is_black }) => {
                if (is_black) {
                    wx.switchTab({
                        url: '/pages/index/main'
                    })
                }
            })
        },
        setWebViewSrc (options) {
            const { link } = options
            if (link) {
                const decodeLink = decodeURIComponent(link)
                const token = Cookie.getItem('token')
                const url = decodeLink.indexOf('?') > -1 ? `${decodeLink}&token=${token}` : `${decodeLink}?token=${token}`
                this.src = url
            }
        },
        errorLoad (err) {
            console.error(err)
        }
    },
    components: {
        PageWrap
    }
}
